import React from "react";
import { createRoot } from "react-dom/client";
import BitrixSearchModal from "./BitrixSearchModal";

// Global configuration interface
export interface LiveSearchConfig {
	triggerSelector?: string;
	apiBasePath?: string;
	placeholder?: string;
	title?: string;
	className?: string;
	autoInit?: boolean;
	containerId?: string;
	bitrixMode?: boolean;
}

// Default configuration
const defaultConfig: LiveSearchConfig = {
	triggerSelector: ".site_s1 .search-input",
	apiBasePath: import.meta.env.VITE_API_BASE_URL || "/local/modules/live_search/api/",
	placeholder: "Что вы хотите найти?",
	title: "Поиск CarolinaShop",
	className: "",
	autoInit: true,
	containerId: "live-search-root",
	bitrixMode: import.meta.env.VITE_BITRIX_MODE === "true" || import.meta.env.VITE_BITRIX_MODE === true,
};

// Global configuration object
declare global {
	interface Window {
		LiveSearchConfig: LiveSearchConfig;
		initLiveSearch: (config?: LiveSearchConfig) => void;
	}
}

/**
 * Initialize Live Search in Bitrix
 *
 * @param config Configuration options
 */
function initLiveSearch(config?: LiveSearchConfig): void {
	// Merge with default config and existing global config
	const globalConfig = window.LiveSearchConfig || {};
	const finalConfig = {
		...defaultConfig,
		...globalConfig,
		...config,
	};

	// Update global config
	window.LiveSearchConfig = finalConfig;

	// Create container if it doesn't exist
	let container = document.getElementById(finalConfig.containerId!);
	if (!container) {
		container = document.createElement("div");
		container.id = finalConfig.containerId!;
		document.body.appendChild(container);
	}

	// Render the component
	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<BitrixSearchModal triggerSelector={finalConfig.triggerSelector} placeholder={finalConfig.placeholder} title={finalConfig.title} className={finalConfig.className} autoInit={finalConfig.autoInit} />
		</React.StrictMode>,
	);

	console.log("Live Search CarolinaShop initialized with config:", finalConfig);
}

/**
 * Auto-initialize if global config is present
 */
function autoInitialize(): void {
	// Check if config exists and autoInit is not false
	if (window.LiveSearchConfig && window.LiveSearchConfig.autoInit !== false) {
		// Wait for DOM to be ready
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => initLiveSearch());
		} else {
			initLiveSearch();
		}
	}
}

// Export init function
export { initLiveSearch };

// Set as global function
if (typeof window !== "undefined") {
	window.initLiveSearch = initLiveSearch;

	// Set default config if not already set
	if (!window.LiveSearchConfig) {
		window.LiveSearchConfig = { ...defaultConfig };
	}

	// Auto-initialize
	autoInitialize();
}

// Default export
export default initLiveSearch;
